import { Route, Routes } from 'react-router-dom';
import Login from './login';

const LoginRouting = () => {
  return (
    <Routes>
      <Route path='' element={<Login />} />
    </Routes>
  );
};

export default LoginRouting;
